import React, { useState } from "react";
import PatientWorkflowSearchingTable from "components/PatientWorkflowSearchingTable";
import { deleteErrorReportById } from "services/errorReports";
import { STATUS } from "../../../constants";
import { downloadErrorReportFile } from "../services/errorReportService";
import { linkErrorReportToWorkflow, moveErrorReportById } from "../../../services/errorReports";
const { LOADING, DEFAULT, SUCCEED, FAILED } = STATUS;

const ReportUploadComponent = ({ file, onFinish }) => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [failureReason, setFailureReason] = useState(null);

  const onSelectPatient = (patient) => setSelectedPatient(patient);

  const [downloadStatus, setDownloadStatus] = useState({ status: DEFAULT });
  const handleDownloadErrorReport = async (e) => {
    setDownloadStatus({ status: LOADING });
    e.preventDefault();
    const id = file?.id;
    if (id) {
      try {
        const res = await downloadErrorReportFile(id);
        const link = document.createElement("a");
        link.href = "data:application/octet-stream;base64," + res.data;
        link.setAttribute("download", id);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setDownloadStatus({ status: SUCCEED });
      } catch (e) {
        setDownloadStatus({ status: FAILED, error: "Fail to download error result" });
      }
    } else {
      setDownloadStatus({ status: FAILED, error: "Error result id is not exist." });
    }
  };

  const handleDeleteReport = async () => {
    setFailureReason(null);
    setIsDeleting(true);

    const { error: deleteError } = await deleteErrorReportById({ id: file?.id });
    if (deleteError) {
      setFailureReason(deleteError.message);
      setIsDeleting(false);
      return;
    }

    onFinish && onFinish();
    setIsDeleting(false);
  };

  const uploadTheReport = async () => {
    setFailureReason(null);
    setIsUploading(true);

    console.log("selectedPatient?.workflowId", selectedPatient?.workflowId);
    console.log("file?.id", file?.id);

    const { error: uploadError } = await moveErrorReportById({ id: file?.id });
    if (uploadError) {
      setFailureReason(uploadError.message);
      setIsUploading(false);
      return;
    }

    await linkErrorReportToWorkflow({
      workflowId: selectedPatient?.workflowId,
      id: file?.id,
      appointmentDate: selectedPatient?.appointmentDate,
      name: selectedPatient?.fullName,
    });
    onFinish && onFinish();
    setIsUploading(false);
  };

  return (
    <>
      <PatientWorkflowSearchingTable selectedPatient={selectedPatient} onSelectPatient={onSelectPatient} />
      <div className="buttons">
        <button
          disabled={!selectedPatient || isUploading}
          className={`button is-primary is-small is-radiusless${isUploading ? " is-loading" : ""}`}
          onClick={uploadTheReport}
        >
          Link Report
        </button>

        <button
          disabled={isUploading || isDeleting}
          className={`button is-small is-danger is-light is-radiusless${isDeleting ? " is-loading" : ""}`}
          onClick={handleDeleteReport}
        >
          Delete Report
        </button>

        <button
          className={`button is-small is-radiusless is-success is-light${
            downloadStatus.status === LOADING ? " is-loading" : ""
          }`}
          onClick={handleDownloadErrorReport}
        >
          Download Report
        </button>

        <p className="has-text-danger is-size-7">{failureReason}</p>
      </div>
    </>
  );
};

export default ReportUploadComponent;
